// @ts-ignore p-queue is an ECMAScript module
import PQueue from 'p-queue'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import api from '@disco/api/server'
import { getWatermarkedTracks } from '@disco/state-management/selectors/tracks'
import { isHlsStreamUrl } from '@disco/utils/file-utils'
import { browserInstanceId } from '@disco/api/server/base'
export const PreloadManager = () => {
  const watermarkedTracks = useSelector(getWatermarkedTracks)
  const cachedM3U8 = useRef({})
  const queue = useRef(
    new PQueue({
      concurrency: 3,
    }),
  )
  const hlsHeaderConfig = {
    'x-playback-session-id': browserInstanceId,
    'x-support-hls': 'v2',
  }
  useEffect(() => {
    watermarkedTracks
      .filter(
        t =>
          t.internal_play_url &&
          isHlsStreamUrl(t.internal_play_url) &&
          (!cachedM3U8.current[t.id] ||
            cachedM3U8.current[t.id] !== t.internal_play_url),
      )
      .forEach(t => {
        queue.current.add(async () => {
          if (cachedM3U8.current[t.id]) return
          await api.preloadHlsManifest(t.internal_play_url, hlsHeaderConfig)
          cachedM3U8.current[t.id] = t.internal_play_url
        })
      })
  }, [watermarkedTracks])
  return null
}
